/* eslint-disable consistent-return */
import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import { useState } from "react";
import useDebounce from "./utils/useDebounce";

const MIN_QUERY_LENGTH = 3;

const normalize = (value: string) =>
    value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

const uniqueValues = (values: string[]) => [...new Set(values)];

const useSearchUserContact = () => {
    const { mailManager } = useSdk();
    const [suggestions, setSuggestions] = useState<string[]>([]);
    const [cachedContacts, setCachedContacts] = useState<string[]>([]);

    const searchUserContact = async (searchString: string) => {
        const normalizedSearch = normalize(searchString);

        if (normalizedSearch.length < MIN_QUERY_LENGTH) {
            setSuggestions([]);

            return [];
        }

        const localMatches = cachedContacts.filter((contact) =>
            normalize(contact).includes(normalizedSearch),
        );

        if (localMatches.length > 0) {
            setSuggestions(localMatches);
        }

        const contacts = await mailManager.searchContact(searchString);
        const mergedContacts = uniqueValues([...cachedContacts, ...contacts]);
        const mergedMatches = mergedContacts.filter((contact) =>
            normalize(contact).includes(normalizedSearch),
        );

        if (contacts.length > 0) {
            setCachedContacts(mergedContacts);
        }

        setSuggestions(mergedMatches.length > 0 ? mergedMatches : localMatches);
    };

    const debouncedSearchUserContact = useDebounce(searchUserContact, 300);

    return { debouncedSearchUserContact, suggestions, setSuggestions };
};

export default useSearchUserContact;
